/* eslint-disable */
export default [{
    showLeftMenu: 1,
    code: "8qavt3",
    auth: false,
    pcode: "",
    auths: [],
    type: 1,
    url: "/example-auto",
    viewTemplate: "common-modules/layout/Layout",
    sons: [{
        showLeftMenu: 1,
        code: "j91sbl",
        auth: false,
        pcode: "8qavt3",
        auths: [],
        type: 1,
        url: "/example-auto/item-list",
        viewTemplate: "",
        sons: [{
                showLeftMenu: 1,
                code: "1an8dc",
                auth: false,
                pcode: "j91sbl",
                auths: [],
                type: 1,
                url: "/example-auto/demouser",
                viewTemplate: "common-modules/parent-view/index",
                sons: [{
                        showLeftMenu: 1,
                        code: "177d73ceeae",
                        auth: false,
                        pcode: "1an8dc",
                        auths: [],
                        type: 2,
                        url: "/example-auto/demouser/item-list-all",
                        viewTemplate: "demoUser/views/item-list",
                        sons: [],
                        name: "用户",
                        id: 6,
                        isGroup: 0,
                        keyword: "example-demouser-item-list-all"
                    },
                    {
                        showLeftMenu: 0,
                        code: "18956de2d7d",
                        auth: false,
                        pcode: "1an8dc",
                        auths: [],
                        type: 2,
                        url: "/example-auto/demouser/new-item",
                        viewTemplate: "demoUser/views/new-item",
                        sons: [],
                        name: "用户新增",
                        id: 7,
                        isGroup: 0,
                        keyword: "example-demouser-new-item"
                    },
                    {
                        showLeftMenu: 0,
                        code: "179516d8228",
                        auth: false,
                        pcode: "1an8dc",
                        auths: [],
                        type: 2,
                        url: "/example-auto/demouser/edit-item/:id",
                        viewTemplate: "demoUser/views/edit-item",
                        sons: [],
                        name: "用户修改",
                        id: 8,
                        isGroup: 0,
                        keyword: "example-demouser-edit-item"
                    },
                    {
                        showLeftMenu: 0,
                        code: "177cf8afc92",
                        auth: false,
                        pcode: "1an8dc",
                        auths: [],
                        type: 2,
                        url: "/example-auto/demouser/item-detail/:id/:indexNum",
                        viewTemplate: "demoUser/views/item-detail",
                        sons: [],
                        name: "用户详情",
                        id: 9,
                        isGroup: 0,
                        keyword: "example-demouser-item-detail"
                    }
                ],
                name: "代码生成单表",
                id: 6,
                isGroup: 0,
                keyword: "example-auto-demouser-item-list"
            },
            {
                showLeftMenu: 1,
                code: "lu7x80",
                auth: false,
                pcode: "j91sbl",
                auths: [],
                type: 1,
                url: "/example-auto/contractmaterials",
                viewTemplate: "common-modules/parent-view/index",
                sons: [{
                        showLeftMenu: 1,
                        code: "178fdf2ae24",
                        auth: false,
                        pcode: "lu7x80",
                        auths: [],
                        type: 2,
                        url: "/example-auto/contractmaterials/item-list",
                        viewTemplate: "contractMaterials/views/item-list",
                        sons: [],
                        name: "物资合同",
                        id: 6,
                        isGroup: 0,
                        keyword: "example-contractmaterials-item-list"
                    },
                    {
                        showLeftMenu: 0,
                        code: "1780edfc330",
                        auth: false,
                        pcode: "lu7x80",
                        auths: [],
                        type: 2,
                        url: "/example-auto/contractmaterials/new-item",
                        viewTemplate: "contractMaterials/views/add/index",
                        sons: [],
                        name: "物资合同新增",
                        id: 7,
                        isGroup: 0,
                        keyword: "example-contractmaterials-new-item"
                    },
                    {
                        showLeftMenu: 0,
                        code: "18a58a4bdfe",
                        auth: false,
                        pcode: "lu7x80",
                        auths: [],
                        type: 2,
                        url: "/example-auto/contractmaterials/edit-item/:id",
                        viewTemplate: "contractMaterials/views/edit/index",
                        sons: [],
                        name: "物资合同修改",
                        id: 8,
                        isGroup: 0,
                        keyword: "example-contractmaterials-edit-item"
                    },
                    {
                        showLeftMenu: 0,
                        code: "1786d6821ff",
                        auth: false,
                        pcode: "lu7x80",
                        auths: [],
                        type: 2,
                        url: "/example-auto/contractmaterials/item-detail/:id/:indexNum",
                        viewTemplate: "contractMaterials/views/detail/index",
                        sons: [],
                        name: "物资合同详情",
                        id: 9,
                        isGroup: 0,
                        keyword: "example-contractmaterials-item-detail"
                    }
                ],
                name: "代码生成主子表",
                id: 6,
                isGroup: 0,
                keyword: "example-auto-contractmaterials-item-list"
            },
            {
                showLeftMenu: 1,
                code: "yhe868",
                auth: false,
                pcode: "j91sbl",
                auths: [],
                type: 1,
                url: "/example-auto/exampleReference",
                viewTemplate: "common-modules/parent-view/index",
                sons: [{
                    showLeftMenu: 1,
                    code: "ij25qi",
                    auth: false,
                    pcode: "yhe868",
                    auths: [],
                    type: 2,
                    url: "/example-auto/exampleReference/item-list-all",
                    viewTemplate: "example/exampleReference/view/item-list",
                    sons: [],
                    name: "参照全部",
                    id: 32,
                    isGroup: 0,
                    keyword: "example-exampleReference-item-list-all"
                }],
                name: "参照",
                id: 6,
                isGroup: 0,
                keyword: "example-auto-exampleReference-item-list"
            },
        ],
        name: "代码生成",
        id: 5,
        isGroup: 0,
        keyword: "example-auto-item-list-index"
    }],
    name: "代码生成",
    id: 4,
    isGroup: 0,
    keyword: "exampleAuto"
}];